import { ENV } from "../Utils";

export class MozillaHubRoomsApi {
  baseApi = ENV.BASE_API;

  async getRooms(accessToken, page = 1, pageSize = 10) {
    try {
      //console.log("token", accessToken);
      const pageFilter = `page=${page}`;
      const limitFilter = `pageSize=${pageSize}`;
      const url = `${this.baseApi}/${ENV.API_ROUTES.HUBROOMS}?${pageFilter}&${limitFilter}`;
      const params = {
        method: "POST", // Asegúrate de especificar el método
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
  /**
   * Crea/abre una sala a partir de una escena de Hubs.
   *
   * `meta` es opcional y solo alimenta la metrica de aperturas del dashboard
   * admin: { source, sceneRefId }. El backend lo ignora si no llega.
   */
  async LoadRoom(accessToken, sceneId, meta = {}) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.LOADROOMS}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json", // Asegúrate de incluir el content type
        },
        body: JSON.stringify({ sceneId, ...meta }), // Stringificar correctamente el objeto JSON
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Baliza de apertura de sala para los flujos que NO crean sala nueva:
   * URLs externas, sala compartida de una tarea, catalogo del usuario free.
   *
   * Es telemetria: nunca lanza ni bloquea la navegacion. Si falla, se pierde
   * ese dato del dashboard y ya.
   */
  async trackRoomOpen(
    accessToken,
    { sceneRefId, shortLink, url, title, source },
  ) {
    try {
      const endpoint = `${this.baseApi}/${ENV.API_ROUTES.TRACKROOMOPEN}`;
      await fetch(endpoint, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        keepalive: true, // sobrevive a la navegacion cuando se abre en la misma pestana
        body: JSON.stringify({ sceneRefId, shortLink, url, title, source }),
      });
    } catch (error) {
      // Silencio deliberado: la metrica no puede romper la entrada a la sala.
    }
  }
}
